import { render, staticRenderFns } from "./ControlSelect.vue?vue&type=template&id=37b24006&"
import script from "./ControlSelect.vue?vue&type=script&lang=js&"
export * from "./ControlSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports